import { Badge, Box, Flex, Heading, Text } from '@radix-ui/themes'
import { type ChangelogVersion } from '#app/data/changelog.server.ts'

export const TYPE_LABELS: Record<
  string,
  { label: string; color: string; order: number }
> = {
  breaking: { label: 'Breaking', color: 'orange', order: 0 },
  feature: { label: 'New', color: 'green', order: 1 },
  improvement: { label: 'Improved', color: 'blue', order: 2 },
  fix: { label: 'Fix', color: 'red', order: 3 },
}

export function ChangelogEntryBadge({ type }: { type: string }) {
  const config = TYPE_LABELS[type] ?? { label: type, color: 'gray' }
  return (
    <Badge
      color={config.color as Parameters<typeof Badge>[0]['color']}
      variant="soft"
      size="1"
      style={{ minWidth: '5.5em', justifyContent: 'center' }}
    >
      {config.label}
    </Badge>
  )
}

export function VersionBlock({ version }: { version: ChangelogVersion }) {
  const sortedChanges = [...version.changes].sort(
    (a, b) =>
      (TYPE_LABELS[a.type]?.order ?? 99) - (TYPE_LABELS[b.type]?.order ?? 99),
  )
  return (
    <Box>
      <Heading size="3" mb="2">
        Version {version.version}
      </Heading>
      <Flex direction="column" gap="1">
        {sortedChanges.map((change, i) => (
          <Flex key={i} gap="2" align="start">
            <ChangelogEntryBadge type={change.type} />
            <Text size="2">{change.description}</Text>
          </Flex>
        ))}
      </Flex>
    </Box>
  )
}
